import React, { memo } from 'react';

import { Page } from '@bonanza-social/navigation';
import Notifications from '../components/Notifications/Notifications';

function NotificationsModal() {
  return (
    <Page>
      <Notifications />
    </Page>
  );
}

export default memo(NotificationsModal);
